<template>
<div class="ActivityGraphWrapper">
  <div class="box box-primary">
    <div class="box-header with-border">
        <h3 class="box-title">{{$t('reports.claimsPerModel')}}</h3>
    </div>
    <el-row>
      <el-col :span="4">
        <el-select @change="choosePeriod($event)" v-model="periodType" value="" reserve-keyword :placeholder="$t('reports.choosePeriod')" :title="$t('reports.choosePeriod')">
          <el-option v-for="item in periodTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="20">
        <el-select @change="chooseProduct($event)" v-model="productId" value="" reserve-keyword :placeholder="$t('reports.chooseModel')" title="$t('reports.chooseModel')">
          <el-option v-for="item in products"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <!-- /.box-header -->
    <div class="box-body">
      <div class="row">
        <div class="col-md-12">
          <line-chart :chartData="chartData" :options="options"></line-chart>
        </div>
      </div>
    </div>
    <!-- /.box-body -->
  </div>
</div>
</template>
<script>
import LineChart from "@/app/reports/components/LineChart";
import api from "../api";
export default {
  name: "graphs",
  components: {
    "line-chart": LineChart
  },
  mounted() {
    this.getData();
  },
  created() {
    this.loadFilters();
  },
  watch: {
    productId: {
      deep: true,
      handler: function() {
        this.getData();
      }
    },
    periodType: {
      deep: true,
      handler: function() {
        this.getData();
      }
    }
  },
  data() {
    return {
      productId: 1,
      products: [],
      periodType: 24,
      periodTypes: [],
      graphVisible: false,
      chartData: {},
      options: {},
      showGraph: false
    };
  },
  methods: {
    loadFilters() {
      api.getFilterForGraph().then(response => {
        this.products = response.data.products;
        this.periodTypes = response.data.periodTypes;
      });
    },
    choosePeriod(period) {
      this.periodType = period;
    },
    chooseProduct(product) {
      this.productId = product;
    },
    getData() {
      var filter = {
        productId: this.productId,
        periodType: this.periodType
      };
      api.getDataForGraph(filter).then(response => {
        let labels = [];
        let datasets = [
          {
            label: "Claims Totals",
            borderColor: "red",
            fill: "false",
            data: []
          }
        ];
        response.data.forEach(x => {
          labels.push(x.yearDate + "/" + x.monthDate);
          datasets[0].data.push(x.total);
        });
        this.chartData = {
          labels: labels,
          datasets: datasets
        };
        this.options = {
          responsive: true,
          maintainAspectRatio: false
        };
        this.showGraph = true;
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// ClientApp/app/reports/components/Graphs.vue